import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/public");
      setSite(data);
    } catch {
      setSite(false);
    }
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  return <SiteContext.Provider value={{ site, reload }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
